/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddUserPermissionRequest
 */
export interface AddUserPermissionRequest {
    /**
     * 
     * @type {any}
     * @memberof AddUserPermissionRequest
     */
    permissionId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof AddUserPermissionRequest
     */
    notifyUserByEmail?: boolean;
}

/**
 * Check if a given object implements the AddUserPermissionRequest interface.
 */
export function instanceOfAddUserPermissionRequest(value: object): value is AddUserPermissionRequest {
    return true;
}

export function AddUserPermissionRequestFromJSON(json: any): AddUserPermissionRequest {
    return AddUserPermissionRequestFromJSONTyped(json, false);
}

export function AddUserPermissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddUserPermissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'permissionId': json['permissionId'] === undefined ? undefined : json['permissionId'] === null ? null : json['permissionId'],
        'notifyUserByEmail': json['notifyUserByEmail'] == null ? undefined : json['notifyUserByEmail'],
    };
}

export function AddUserPermissionRequestToJSON(json: any): AddUserPermissionRequest {
    return AddUserPermissionRequestToJSONTyped(json, false);
}

export function AddUserPermissionRequestToJSONTyped(value?: AddUserPermissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissionId': value['permissionId'],
        'notifyUserByEmail': value['notifyUserByEmail'],
    };
}

